import React, { Component } from "react";
// import { AuthLogin } from "../../services/auth-service";
import { restauth, app } from "../../index";
// import { queryservice } from "../../services/crudservice";
import { invformatnumber } from "../../services/tnminvnumbers";

import { Modal, Header, Table } from "semantic-ui-react";
import moment from "moment";
import { hashHistory } from "react-router";
class InvoiceListModal extends Component {
  constructor() {
    super();
    // sets false if there are no derivatives in the root wod.
    this.state = {
      derivlist: true,
      header: "",
      invlist: null
    };
  }
  componentDidMount() {
    this.queryinv();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.similarwods != this.props.similarwods) {
      this.queryinv();
    }
  }
  componentWillUnmount() {
    this.props.closemodal();
  }
  queryinv() {
    var wodlist;
    if (
      this.props.similarwods &&
      this.props.similarwods.length &&
      this.props.wod.invWorkOrderMain
    ) {
      wodlist = this.props.similarwods.map(wod => {
        return wod.workOrderNbr;
      });
      wodlist = wodlist.concat(this.props.wonum);
    } else {
      wodlist = [this.props.wonum];
      if (this.props.wod.invWorkOrderMain) {
        wodlist = wodlist.concat(this.props.wonum.slice(0, 7));
      }
    }
    console.log("Wodlist", wodlist);
    app
      .service("invoices")
      .find({
        query: {
          workordernumber: { $in: wodlist }
        }
      })
      .then(response => {
        response = response.data ? response.data : response;
        console.log("Invoices", response, "Wonum", this.props.wonum);
        // update wod state for tmreport button
        this.props.updateWodState(response);
        if (response.length) {
          this.setState({ invlist: response });
        }
      });
  }

  gentable() {
    if (this.props.invlist && this.props.invlist.length) {
      return (
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="center">
                Invoice Number
              </Table.HeaderCell>
              <Table.HeaderCell>Start Date</Table.HeaderCell>
              <Table.HeaderCell>End Date</Table.HeaderCell>
              <Table.HeaderCell>Paid Date</Table.HeaderCell>
              <Table.HeaderCell>Charge</Table.HeaderCell>
              <Table.HeaderCell>Paid</Table.HeaderCell>
              <Table.HeaderCell colSpan="3">Comments</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.geninvlist()}</Table.Body>
        </Table>
      );
    }
  }
  geninvlist() {
    if (this.props.invlist.length) {
      return this.props.invlist.map(inv => {
        if (!inv.paiddate && inv.amount == inv.paidamount) {
          inv.paiddate = inv.updatedAt;
        }
        return (
          <Table.Row positive={inv.number}>
            <Table.Cell
              textAlign="center"
              selectable
              onClick={() => hashHistory.push("/invlist/" + inv.id)}
            >
              {" " + invformatnumber(inv)}
            </Table.Cell>
            <Table.Cell>
              {moment(inv.periodbegindate).format("MM/DD/YY")}
            </Table.Cell>
            <Table.Cell>
              {moment(inv.periodenddate).format("MM/DD/YY")}
            </Table.Cell>
            <Table.Cell>
              {inv.paiddate ? moment(inv.paiddate).format("MM/DD/YY") : "N/A"}
            </Table.Cell>
            <Table.Cell>{"$" + inv.amount}</Table.Cell>
            <Table.Cell>{"$" + inv.paidamount}</Table.Cell>
            <Table.Cell>{inv.invcomments}</Table.Cell>
          </Table.Row>
        );
      });
    } else {
      return <h3>No Time or Materials for this Workorder/Derivative</h3>;
    }
  }

  render() {
    return (
      <div className="RelatedWods">
        <Modal
          open={this.props.showModal}
          onClose={() => this.props.closemodal()}
          basic={!this.state.derivlist}
          closeOnEscape
          size="fullscreen"
          closeOnRootNodeClick
        >
          <Header textAlign="center">
            {"Invoices for " + this.props.wonum}
          </Header>
          <Modal.Content>{this.gentable()}</Modal.Content>
        </Modal>
      </div>
    );
  }
}

export default InvoiceListModal;



// WEBPACK FOOTER //
// ./src/components/wod/invlistmodal.jsx